
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members-festival-referral",
      function () {
        return require("private-next-pages/members-festival-referral/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members-festival-referral"])
      });
    }
  